import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { GlobalHttpClient } from '../global.http.client';
import { IPage } from '../models/common/paging';
import { BaseService } from './base.service';
import { ISearchService } from './search.service';
import { Configuration } from '../configuration';
import { MatchingTenderSearchRequest, MatchingTenderSummaryDto, RemoveMatchDto, RemoveMatchesDto } from '../models/tenders/matching.tender.models';
import { Router } from '@angular/router';
import { Helpers } from '../helpers';

@Injectable()
export class MatchingTenderService extends BaseService implements ISearchService<MatchingTenderSearchRequest,
MatchingTenderSummaryDto> {

    constructor(private readonly helpers: Helpers, http: GlobalHttpClient, private configuration: Configuration, public router: Router) {
        super(http);
    }

    search(request: MatchingTenderSearchRequest): Observable<IPage<MatchingTenderSummaryDto>> {
        return this.http.getWithParams<IPage<MatchingTenderSummaryDto>>('tenders/mymatches', request);
    }

    removeMatch(matchId: number) {
        var response = this.http.deleteWithParams('noticeActions/removeMatch', { matchingTenderId: matchId });

        return response;
    }

    removeMatches(ids: Array<number>) {

        var response: Observable<unknown>;

        var dto = new RemoveMatchesDto();
        dto.matches = [];

        ids.forEach((id) => {
            var match = new RemoveMatchDto();
            match.matchingTenderId = id;
            dto.matches.push(match);
        });

        response = this.http.post('noticeActions/removeMatches', dto);

        return response;
    }

    checkTender(tenderId: number) {
        return this.http.get(`tenders/checkTender/${tenderId}`);
    }

    downloadCsv(request: MatchingTenderSearchRequest) {
        var url = `${this.configuration.routing.api.baseUrl}/tenders/getMatchesCsv?${this.helpers.uriEncode(request)}`;
        window.location.href = url;
    }
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Client/app/services/matching.tender.service.ts